import React from 'react';
import { observer } from 'mobx-react-lite';
import { ResidentMenu } from 'src/components/tenant/ResidentMenu';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
export const ActionsCell = observer(_ref => {
  var _params$row, _params$row2;
  let buildingId = _ref.buildingId,
    params = _ref.params,
    openTenantModal = _ref.openTenantModal,
    setMmodalTempData = _ref.setMmodalTempData;
  return /*#__PURE__*/React.createElement(ResidentMenu, {
    params: params,
    buildingId: buildingId,
    propertyId: params.row.propertyId,
    accountId: params.row.accountId,
    openTenantModal: openTenantModal,
    residencyId: params.row.residencyId,
    setMmodalTempData: setMmodalTempData,
    isNotVacant: !!params.row.accountId && !((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled) || ((_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.status) === RESIDENCY_STATUS_KEY_VALUES.Future
  });
});